import React, { useState } from 'react';
import CreatePackage from './CreatePackage';
import PackagesTable from './PackagesTable';
import SearchPackages from './SearchPackages';
import SearchPackagesReq from '../../../Classes/Models/Requests/AccountingSessions/CreatePackageReq';
import Loader from 'Loader';

const Index = () => {
  const [SearchReq, setSearchReq] = useState(new SearchPackagesReq());
  const [IsLoaded, setIsLoaded] = useState(true);

  const handleSearch = (newSearchReq) => {
    // Set the new search request and trigger loader
    setIsLoaded(false); // Show loader
    setSearchReq(newSearchReq);
    setTimeout(() => {
      
      setIsLoaded(true);
    }, 10);
  };

  return (
    <>
      {/* <CreatePackage setCreatedNewPackage={setCreatedNewPackage} /> */}
      <SearchPackages setSearchReq={handleSearch} />
      {!IsLoaded ? (
        <Loader />
      ) : (
        <PackagesTable SearchReq={SearchReq} setSearchReq={setSearchReq} setIsLoaded={setIsLoaded} />
      )}
    </>
  );
};

export default Index;
